export interface Bonus {
  label: string
  title: string
  body: string
}

export const bonuses: Bonus[] = [
  {
    label: '🎁 BONUS 1',
    title: 'CROP NUTRITION FIELD ASSESSMENT TOOLKIT™',
    body: 'Organize professional crop inspections with field observation forms, symptom distribution records, photographic documentation guides, nutritional assessment worksheets, and follow-up inspection templates.',
  },
  {
    label: '🎁 BONUS 2',
    title: 'SOIL & PLANT TISSUE SAMPLING PROTOCOL KIT™',
    body: 'Improve sampling organization with soil and tissue collection planning sheets, sample identification records, laboratory submission checklists, contamination prevention references, and sample tracking tools.',
  },
  {
    label: '🎁 BONUS 3',
    title: 'CROP NUTRIENT MANAGEMENT PLANNING SYSTEM™',
    body: 'Structure crop nutrition programs with nutrient input planning worksheets, fertilizer application records, laboratory information reviews, nutrient source inventories, and professional management tracking templates.',
  },
  {
    label: '🎁 BONUS 4',
    title: 'NUTRIENT CORRECTION & CROP RESPONSE MONITORING KIT™',
    body: 'Document corrective actions and monitor crop development with baseline condition records, intervention tracking forms, symptom progression worksheets, photographic comparisons, and follow-up evaluation tools.',
  },
  {
    label: '🎁 BONUS 5',
    title: 'AGRONOMY CLIENT REPORTING & NUTRITION ADVISORY KIT™',
    body: 'Prepare professional crop nutrition reports with consultation templates, laboratory findings summaries, visual evidence records, recommendation documentation forms, and client follow-up reports.',
  },
]
